import * as React from 'react';
import OrderHeader from '../Header/OrderHeader.js';

const Order = ({ children , footer , orderDate , orderNumber , shipmentStatus , orderStatus , paymentStatus , receiptUrl , returnUrl , shipmentTrackingUrl , onTraceOrder , onReorder , onOpenCancelReturnsModal , onCloseCancelReturnsModal , onDownloadReceiptClick , onClickReturn , isCancelReturnsModalOpen , isPaid , isReturnable , isReturnsEnabled , isOrderWorkflowStatusEnabled , showOrderDate ,  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(OrderHeader, {
        orderDate: orderDate,
        orderNumber: orderNumber,
        shipmentStatus: shipmentStatus,
        orderStatus: orderStatus,
        paymentStatus: paymentStatus,
        isPaid: isPaid,
        isReturnable: isReturnable,
        isReturnsEnabled: isReturnsEnabled,
        isOrderWorkflowStatusEnabled: isOrderWorkflowStatusEnabled,
        receiptUrl: receiptUrl,
        returnUrl: returnUrl,
        shipmentTrackingUrl: shipmentTrackingUrl,
        onTraceOrder: onTraceOrder,
        onReorder: onReorder,
        onOpenCancelReturnsModal: onOpenCancelReturnsModal,
        onCloseCancelReturnsModal: onCloseCancelReturnsModal,
        onDownloadReceiptClick: onDownloadReceiptClick,
        onClickReturn: onClickReturn,
        isCancelReturnsModalOpen: isCancelReturnsModalOpen,
        className: "order__header",
        showOrderDate: showOrderDate
    }), children, footer && /*#__PURE__*/ React.createElement("div", {
        className: "order__footer"
    }, footer));
};

export { Order, Order as default };
//# sourceMappingURL=Order.js.map
